import giftGuide from './giftGuide.js';
import { onDOMContentLoaded } from '../../dom/events';

onDOMContentLoaded(() => giftGuide.init());